/* tslint:disable */

declare var Object: any;
export interface FileManagerInterface {
  "file_name": string;
  "file_type"?: string;
  "file_description"?: string;
  "id"?: number;
}

export class FileManager implements FileManagerInterface {
  "file_name": string;
  "file_type": string;
  "file_description": string;
  "id": number;
  constructor(data?: FileManagerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FileManager`.
   */
  public static getModelName() {
    return "FileManager";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FileManager for dynamic purposes.
  **/
  public static factory(data: FileManagerInterface): FileManager{
    return new FileManager(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FileManager',
      plural: 'FileManagers',
      path: 'FileManagers',
      properties: {
        "file_name": {
          name: 'file_name',
          type: 'string'
        },
        "file_type": {
          name: 'file_type',
          type: 'string'
        },
        "file_description": {
          name: 'file_description',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/FileManager.ts